import { Content, FormatContent } from 'src/contexts/ContentContext';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { CheckIcon, ErrorIcon } from 'src/svgs';
import { PendingAllocationIcon } from 'src/svgs/PendingAllocationIcon';
import { ContentId } from 'src/utils/constants/contentId';
import { FormatContentId } from 'src/utils/constants/formatContentId';

import { SlotCreationStatus } from '../EventGroup.types';
import * as styles from './EventGroupCreatingStep.css';

type EventGroupCreatingStepProps = {
  count: number;
  statuses: SlotCreationStatus[];
};

const StatusIcon = ({ status }: { status: SlotCreationStatus }) => {
  switch (status) {
    case 'pending':
      return (
        <PendingAllocationIcon
          size={vars.iconSize.l}
          className={styles.pendingIcon}
        />
      );
    case 'in-progress':
      return <PosSpinner size={vars.iconSize.xxs} centered={false} />;
    case 'done':
      return (
        <CheckIcon size={vars.iconSize.l} stroke={vars.color.iconSuccess} />
      );
    case 'error':
      return <ErrorIcon size={vars.iconSize.l} />;
  }
};

export const EventGroupCreatingStep = ({
  count,
  statuses,
}: EventGroupCreatingStepProps) => {
  return (
    <Stack direction="column" gap="m" className={styles.container}>
      <div>
        <div className={styles.title}>
          <Content id={ContentId.CreatingEventGroup} />
        </div>
        <div className={styles.subtitle}>
          <Content id={ContentId.CreatingPlaceholderEventsDescription} />
        </div>
      </div>

      <Stack direction="column" gap="m">
        {Array.from({ length: count }, (_, i) => (
          <Stack key={i} direction="row" gap="m" alignItems="center">
            <StatusIcon status={statuses[i] ?? 'pending'} />
            <span className={styles.eventLabel}>
              <FormatContent
                id={FormatContentId.EventNumber}
                params={[String(i + 1)]}
              />
            </span>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
